
import { React } from '../../react';

import cx from './style.less';
import { round_dec } from '@zaibot/mathlib';

/* tslint:disable no-magic-numbers*/
export type ModalType = 'flyover' | 'flyover2' | 'top' | 'maximized' | 'center'| 'center2nd' | 'smallsize1' | 'smallscreen';

export interface IModalProps {
  header?: React.ReactChild;
  arialabel?: string;
  onClick?: () => any;
  onEscKeyDown?: () => any;
  transform: { translateY: string; opacity: number; zIndex: number; };
  type: ModalType;
  visible: boolean;
  backdrop?: boolean;
  minimized?: boolean;  
}

export default class Plain extends React.Component<IModalProps, {}> {
  public render() {
    const {
      children,
      arialabel,
      header, 
      onClick,
      onEscKeyDown,
      transform,
      type,
      backdrop,
      visible,
      minimized,
  } = this.props;
    
    if (backdrop)
    return (
        <div>
          <div className={cx('backdrop')} 
              style={{ opacity: backdropOpacity(visible? 1 : 0) }} 
              aria-hidden="true" 
                onClick={(ev) => { ev.preventDefault(); return onEscKeyDown();} }
                onMouseDown={(ev) => { ev.preventDefault(); return onEscKeyDown();}}></div>
          <div 
            onKeyDown={(ev) => {if (ev.key==='Escape') {ev.preventDefault(); return onEscKeyDown();}} }            
            className={cx('container', type, minimized ? 'minimized' : '', visible ? 'wcag-visible': 'wcag-invisible')}
            style={{ transform: `translateY(${transform.translateY})`, opacity: transform.opacity, zIndex: type === 'center' || type === 'center2nd' || type==='maximized' ? transform.zIndex : undefined }}
            role="dialog" 
            aria-label={arialabel}
            aria-labelledby={!arialabel?'aria-labelledby-id':''}
            onClick={onClick}>
            <div className={cx('component', type, minimized ? 'minimized' : '')}>
              <div className={cx('shadow', type)} />
              <div id={'aria-labelledby-id'}> 
                {header}
              </div>
              <div className={cx('content', type)}>
                {children}
              </div>
            </div>
          </div>
        </div>
    );      
    return (
        <div 
              onKeyDown={(ev) => {if (ev.key==='Escape') return onEscKeyDown();} }
              // onOverlayClick={onEscKeyDown}
              className={cx('container', type)}
              style={{ transform: `translateY(${transform.translateY})`, opacity: transform.opacity, zIndex: type === 'center' ? transform.zIndex : undefined }}
              onClick={onClick}
              role="dialog" 
              aria-label={arialabel}
              aria-labelledby={!arialabel ? 'dialogHeader' : ''}
              >
              <div className={cx('component', type)}>
                <div className={cx('shadow', type)} />
                {header}
                <div className={cx('content', type)}>
                  {children}
                </div>
              </div>
        </div>
    );
  }
}

/* tslint:disable no-magic-numbers */
function backdropOpacity(input: number) {
  return round_dec(Math.pow(input, 2) * .5, 1);
}
/* tslint:enable */



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/modal/plain.tsx